import BaseText from '../base-text/base-text.component';
import ParagraphProps from './paragraph.props';
import {TypographySizes, TypographyVariants} from '../base-text/constants';
import styles from './paragraph.styles';

function Paragraph({
  size = TypographySizes.M,
  ...baseTextProps
}: ParagraphProps) {
  return (
    <BaseText
      {...baseTextProps}
      size={size}
      variant={TypographyVariants.Paragraph}
      style={styles[size]}
    />
  );
}

export default Paragraph;
